/* eslint-disable react/prop-types */
import React, { useRef } from 'react';

function useKeepNonNullValue(value) {
  const valueRef = useRef(value);
  // Auto-update
  if (value) {
    valueRef.current = value;
  }
  return valueRef.current;
}

/**
 * When using CSSTransitions, match switches to null and this breaks match.params
 * @param {*} Component
 */
export function withAnimatedRouterMatch(Component) {
  return ({ match, ...props }) => {
    const validMatch = useKeepNonNullValue(match);
    return <Component match={validMatch} {...props} />;
  };
}
